<div class="app-shell" [class.app-shell--scaled]="isMobile && forceDesktopView" [attr.aria-hidden]="showMobileBlocker ? 'true' : null">
  <router-outlet></router-outlet>
</div>

<section class="mobile-blocker" *ngIf="showMobileBlocker" aria-label="Desktop required">
  <div class="mobile-blocker__content">
    <div class="mobile-blocker__icon" aria-hidden="true">
      <svg viewBox="0 0 64 64" role="img" focusable="false">
        <rect x="10" y="12" width="44" height="30" rx="4" ry="4" fill="none" stroke="currentColor" stroke-width="3" />
        <path d="M24 52h16" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" />
        <path d="M32 42v10" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" />
        <circle cx="32" cy="27" r="8" fill="none" stroke="currentColor" stroke-width="3" />
        <path d="M32 27v-4" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" />
        <path d="M32 27l4 2" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" />
      </svg>
    </div>

    <h1 class="mobile-blocker__title">You’re all set. We just need a bigger screen.</h1>
    <p class="mobile-blocker__subtitle">
      The full experience is designed for desktop. Mobile is coming soon. For now, log in from your laptop or computer.
    </p>

    <button type="button" class="mobile-blocker__button" (click)="enableDesktopView()">
      Desktop View
    </button>
  </div>
</section>
